import React, { useEffect, useMemo, useState } from "react"
import PropTypes from "prop-types"
import { Link } from "react-router-dom"
import { isEmpty } from "lodash"
import "bootstrap/dist/css/bootstrap.min.css"
import TableContainer from "../../components/Common/TableContainer"
import * as Yup from "yup"
import { useFormik } from "formik"
import toastr from "toastr"
//import components
import Breadcrumbs from "../../components/Common/Breadcrumb"
import Switch from "react-switch"
import {
  getUsers as onGetUsers,
  addNewUser as onAddNewUser,
  updateUser as onUpdateUser,
  deleteUser as onDeleteUser,
} from "../../store/actions"

import { Position, Email, Name} from "../Contacts/ContactList/ContactListCol"

//redux
import { useSelector, useDispatch } from "react-redux"
import classnames from "classnames"
import Select from "react-select";
import {
  Col,
  Row,
  UncontrolledTooltip,
  Modal,
  ModalHeader,
  ModalBody,
  Form,
  Input,
  FormFeedback,
  Label,
  Card,
  CardTitle,
  Button,
  Nav,
  CardBody,
  DropdownToggle,
  UncontrolledDropdown,
  DropdownMenu,
  DropdownItem,
  NavItem,
  Table,
  NavLink,
  Container,
  TabContent,
  TabPane
} from "reactstrap"
import DeleteModal from "../../components/Common/DeleteModal"
import axios from "../../axios"
import SweetAlert from "react-bootstrap-sweetalert";
import moment from 'moment'
import numeral from "numeral";
function DatatableTables() {
  const [modal, setModal] = useState(false)
  // const [modal1, setModal1] = useState(false);
  const [isEdit, setIsEdit] = useState(false)
  const [tokent, settokent] = useState('Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJldmVudGxpc3QiOlt7IlVzZXJJRCI6IjEiLCJMb2dpbkNvZGUiOiIwMSIsIkxvZ2luTmFtZSI6IkFkbWluIiwiRW1haWxJZCI6ImFkbWluQGdtYWlsLmNvbSIsIlVzZXJUeXBlIjoiQURNSU4ifV0sImlhdCI6MTYzODM1NDczMX0.ZW6zEHIXTxfT-QWEzS6-GuY7bRupf2Jc_tp4fXIRabQ')
  const [switch1, setswitch1] = useState(true)
  const [userList, setUserList] = useState([])
  const [user, setUser] = useState([])
  const [activeTab, setactiveTab] = useState("1")
  const [activeTab1, setactiveTab1] = useState("5")
  const [activeTabV, setactiveTabV] = useState("15")
  //const [activeTab2, setactiveTab2] = useState("9");
  //const [activeTab3, setactiveTab3] = useState("13");
  const [activeTabJustify, setactiveTabJustify] = useState("5")
  const [activeTabJustify1, setactiveTabJustify1] = useState("20")
  const [activeTabJustify2, setactiveTabJustify2] = useState("25")
  const [activeTabJustify3, setactiveTabJustify3] = useState("30")
const [Deletiid, setDeletiid] = useState('');
  const [col1, setcol1] = useState(true)
  const [col2, setcol2] = useState(false)
  const [col3, setcol3] = useState(false)
  const [col5, setcol5] = useState(true)
  const [col6, setcol6] = useState(true)
  const [col7, setcol7] = useState(true)
  const [col8, setcol8] = useState(true)
  const [col9, setcol9] = useState(false)
  const [col10, setcol10] = useState(false)
  const [Buyerinfo, setBuyerinfo] = useState(false);
  const [Buyersuccess, setBuyersuccess] = useState(false);
  const [Buyererr, setBuyererr] = useState(false);
  const [buyerGirddata, setbuyerGirddata] = useState([]);
  const [allcustomercollections, setallcustomercollections] = useState([])
  const PhoneRegExps = /^[0-9 () +-]+$/
  const [countryid, setcountryid] = useState('')
  const [stateid, setstateid] = useState('')
  const [cityid, setcityid] = useState('')
  const [allcountrycollections, setallcountrycollections] = useState([])
  const [allcitycollections, setallcitycollections] = useState([])
  const [allstatecollections, setallstatecollections] = useState([])
  const [duplicateerro, setduplicateerro] = useState(false);
  const [statecode, setstatecode] = useState('')
  const [satename, setsatename] = useState('')
  const [allgroupcollections, setallgroupcollections] = useState([])
  const [groupname, setgroupname] = useState('')
  const [subgroup, setsubgroup] = useState('')
  const [onecitycollections, setonecitycollections] = useState([])
  const [cityonedefaultvalue, setcityonedefaultvalue] = useState({label:"Select...",value:""})
  const [onestaecollations, setonestaecollations] = useState([])
  const [onestatedefaultvalue, setonestatedefaultvalue] = useState({label:"Select...",value:""})
  const [onecountrycollections, setonecountrycollections] = useState([])
  const [onecountrydefaultvalue, setonecountrydefaultvalue] = useState({label:"Select...",value:""})
  const [registerdate, setregisterdate] = useState(new Date())
  const [BuyerCollection, setBuyerCollection] = useState({
    Customer_Name:"",
Customer_Code:"",
Contact_Person:"",
Type:"Corporate",
Address1:"",
Address2:"",
Area_Code:"",
City:"",
Zip_Code:"",
State:"",                          
Country:"",
Phone:"",
Fax:"",
EmailId:"",
TIN_No:"",

Company_Id:"",
Active:"",       
Group_Id:"",
PANNo:"",
STNo:"",
GSTNo:"",
AccNo:"",
AccBranch:"",              
IFSCCode:"",
bank:"",
CityId:"",              
RegisterType:"Registered",
StateId:"",
CountryId:"",
StateCode:""   
  });
  function toggle12(tab) {
    if (activeTab !== tab) {
      setactiveTab(tab)
    }
  }


  const tab1validtiontab1 =(tab) => {
  
    //  //console.log((validation.values.Customer_Name.length),(validation.values.Contact_Person.length),(validation.values.Address1.length),(validation.values.Phone.length),(validation.values.Zip_Code.length),(validation.values.EmailId.length),(validation.values.Type.length))

    
    if(validation.values.Customer_Name.length  > 0 && validation.values.Address1.length > 1 && validation.values.Phone.toString().length>9   && validation.values.EmailId.length > 0  ) {

      
      if (activeTab !== tab) {
      
        
        setactiveTab(tab)
       }
      }else {
           validation.setFieldTouched('Customer_Name')
           validation.setFieldTouched('Address1')
          validation.setFieldTouched('Phone')
       
      
          validation.setFieldTouched('EmailId')
   
      
         
         
         }

  } 

  



  const tab1validtiontab2 =(tab) => {
   // //console.log(validation.errors)
       //console.log(validation.values.RegisterType != 'Registered','ttt', )
        if(validation.values.RegisterType != 'Unregistered' && validation.values.RegisterType !='Composition'){

       
  if (validation.values.GSTNo.length > 14  ) {

 
    if (activeTab !== tab  ) {
      setactiveTab(tab)
    }

    
   
  
  }else {
    
    validation.setFieldTouched('GSTNo')

  }
 }else{
validation.values.GSTNo ='               '
 

 if (activeTab !== tab  ) {
   setactiveTab(tab)
 }
  } 
  
}

 
  const phoneRegExp =/^[0-9 () +-]+$/
  const Country = /^[a-zA-Z ]+$/
  // validation
  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues:BuyerCollection,
    validationSchema: Yup.object({
        Customer_Name: Yup.string().required("Please Enter Customer Name").max(100,"Customer Name Must Be Atmost 100 Characters"),
        Contact_Person: Yup.string().max(50,"Contact Person Must Be Atmost 50 Characters"),
        Address1:Yup.string().required("Please Enter  Address1"),
     
        Zip_Code:Yup.string().min(3,'Pin Code Must Be atleast 3 Digits').max(6,'Pin Code  Must Be Atmost 6 Digits'),
        Phone:Yup.string().min(10, 'Phone No Must Be Atleast 10 Digits').max(15,'Phone No Must Be Atmost 15 Digits').matches(PhoneRegExps, 'Please Enter valid Phone No').required('Please Enter Phone No'),
        EmailId:Yup.string().email('EmailId  Must Be Valid').required('Please Enter EmailId'),
        GSTNo:Yup.string().min(15, 'GST No Must Be Atleast 15 Digits').max(15,'GST No Must Be Atmost 15 Digits').required('Please Enter GST No'),
        Fax:Yup.string().max(10,' Fax No Must Be Atmost 10 Digits '),
        Area_Code:Yup.string().min(10,'Mobile No Must Be Atleast 10 Digits ').max(15,'Mobile No Must be Atmost 15 Digits'),
        bank:Yup.string().max(50,'Bank Name Must Be atmost 50 Characters'),
        IFSCCode:Yup.string().max(30,'IFSCCode Must Be Atmost 30 Characters'),
        AccNo:Yup.string().max(30,'Account No Must Be Atmost 30 Characters'),
        AccBranch:Yup.string().max(30,'Branch Name Must Be Atmost 30 characters'),
        PANNo:Yup.string().max(30, 'PANNo Must Be Atmost 30 Characters')
 

      }),
    onSubmit:async (values) => {
      if (isEdit) {
        const CreateBuyer =  await  axios.instance.put(`/Updatecustomerdetils/${validation.values.Customer_Id}`, 
        {
          Customer_Name:values.Customer_Name,
          Customer_Code:"",
          Contact_Person:values.Contact_Person,
          Type:values.Type,
          Address1:values.Address1,
          Address2:values.Address2,
          Area_Code:values.Area_Code,
          City:cityid,
          Zip_Code:values.Zip_Code,
          State:stateid,                          
          Country:countryid,
          Phone:values.Phone,
          Fax:values.Fax,
          EmailId:values.EmailId,
          TIN_No:values.TIN_No,
         
          Company_Id:localStorage.getItem('CompanyId'),
          Active: switch1 ? 'Y' : 'N',       
          Group_Id:27,
          PANNo:values.PANNo,
          STNo:values.STNo,
          GSTNo:values.GSTNo,
          AccNo:values.AccNo,
          AccBranch:values.AccBranch,              
          IFSCCode:values.IFSCCode,
          bank:values.bank,
          CityId:2,              
          RegisterType:values.RegisterType,
          StateId:satename,
          CountryId:2,
          StateCode:statecode ,
          Modify_By: localStorage.getItem('UserId'),
        Modify_Date:new Date(),
          IssueDate:registerdate
        }
        ,{ headers: {'Authorization':tokent,
       'Content-Type': 'application/json'
       }}).then((res) => {
     //console.log(res.data)
         if(res.data === '') {
          setBuyerinfo(true)
          setactiveTab('1')
          setBuyerCollection({
            Customer_Name:"",
            Customer_Code:"",
            Contact_Person:"",
            Type:"",
            Address1:"",
            Address2:"",
            Area_Code:"",
            City:"",
            Zip_Code:"",
            State:"",                          
            Country:"",
            Phone:"",
            Fax:"",
            EmailId:"",
            TIN_No:"",
            
            Company_Id:"",
            Active:"",       
            Group_Id:"",
            PANNo:"",
            STNo:"",
            GSTNo:"",
            AccNo:"",
            AccBranch:"",              
            IFSCCode:"",
            bank:"",
            CityId:"",              
            RegisterType:"",
            StateId:"",
            CountryId:"",
            StateCode:""  
          })
          getallcustomers()
          toggle()
          // save new user
          //dispatch(onAddNewUser(newUser))
          validation.resetForm()
   
   
         }else {
           setduplicateerro(true)
         }




       })
       
        // update user
        //dispatch(onUpdateUser(updateUser))
        //validation.resetForm()
      } else {
         const CreateBuyer =  await  axios.instance.post(`/insertcustomerdetails`, 
         {
          Optype:'New',
            Customer_Name:values.Customer_Name,
            Customer_Code:"",
            Contact_Person:values.Contact_Person,
            Type:values.Type,
            Address1:values.Address1,
            Address2:values.Address2,
            Area_Code:values.Area_Code,
            City:cityid === ''  ? 0 :  cityid,
            Zip_Code:values.Zip_Code,
            State:stateid === '' ?  0 : stateid,                          
            Country:countryid === '' ? 0 :  countryid,
            Phone:values.Phone,
            Fax:values.Fax,
            EmailId:values.EmailId,
            TIN_No:values.TIN_No,
            Created_By:localStorage.getItem('UserId'),
            Created_Date:new Date(),
            Company_Id:localStorage.getItem('CompanyId'),
            Active: switch1 ? 'Y' : 'N',       
            Group_Id:27,
            PANNo:values.PANNo,
            STNo:values.STNo,
            GSTNo:values.GSTNo,
            AccNo:values.AccNo,
            AccBranch:values.AccBranch,              
            IFSCCode:values.IFSCCode,
            bank:values.bank,
            CityId:2,              
            RegisterType:values.RegisterType,
            StateId:satename,
            CountryId:2,
            StateCode:statecode,
            IssueDate:registerdate
         }
         ,{ headers: {'Authorization':tokent,
        'Content-Type': 'application/json'
        }}).then((res) => {
          getallcustomers()
            //console.log(res.data)
          if(res.data.length ===1) {
            setactiveTab('1')
            setBuyerCollection({
                Customer_Name:"",
                Customer_Code:"",
                Contact_Person:"",
                Type:"",
                Address1:"",
                Address2:"",
                Area_Code:"",
                City:"",
                Zip_Code:"",
                State:"",                          
                Country:"",
                Phone:"",
                Fax:"",
                EmailId:"",
                TIN_No:"",
                
                Company_Id:"",
                Active:"",       
                Group_Id:"",
                PANNo:"",
                STNo:"",
                GSTNo:"",
                AccNo:"",
                AccBranch:"",              
                IFSCCode:"",
                bank:"",
                CityId:"",              
                RegisterType:"",
                StateId:"",
                CountryId:"",
                StateCode:""   
            })
          
            toggle()
            setBuyersuccess(true)
            validation.resetForm()
          }else {
            setduplicateerro(true)
          }
      
       
        // save new user
        //dispatch(onAddNewUser(newUser))
       
      })
    
        
      
      }
    },
  })

  // const toggleViewModal = () => setModal1(!modal1);


  const toggle = () => {
    if (modal) {
      setModal(false)
      setUser(null)
      setBuyerCollection({
        Customer_Name:"",
        Customer_Code:"",
        Contact_Person:"",
        Type:"",
        Address1:"",
        Address2:"",
        Area_Code:"",
        City:"",
        Zip_Code:"",
        State:"",                          
        Country:"",
        Phone:"",
        Fax:"",
        EmailId:"",
        TIN_No:"",
        
        Company_Id:"",
        Active:"",       
        Group_Id:"",
        PANNo:"",
        STNo:"",
       
        AccNo:"",
        AccBranch:"",              
        IFSCCode:"",
        bank:"",
        CityId:"",              
        RegisterType:"",
        StateId:"",
        CountryId:"",
        StateCode:""   
      })
      validation.values.GSTNo=33
     
      validation.values.RegisterType === 'Unregistered' && validation.values.GSTNo === '' 
      validation.resetForm()
  
  
      setactiveTab('1')
    } else {
      setModal(true)
    }

 
      
    
  }

  const handleUserClick = arg => {
    const Buyer = arg
//console.log('ss',arg)
  //console.log('ss',arg.GSTNo === '               ')
if(Buyer.Active === 'Y') {
  setswitch1(true)
}else {
  setswitch1(false)
}
    setBuyerCollection({
      Customer_Id:Buyer.Customer_Id,
      Customer_Name:Buyer.Customer_Name,
        Customer_Code:Buyer.Customer_Code,
        Contact_Person:Buyer.Contact_Person,
        Type:Buyer.Type,
        Address1:Buyer.Address1,
        Address2:Buyer.Address2,
        Area_Code:Buyer.Area_Code,
        City:Buyer.City,
        Zip_Code:Buyer.Zip_Code,
        State:Buyer.State,                          
        Country:Buyer.Country,
        Phone:Buyer.Phone,
        Fax:Buyer.Fax,
        EmailId:Buyer.EmailId,
        TIN_No:Buyer.TIN_No,
        
        IssueDate:Buyer.IssueDate,
           
      
        PANNo:Buyer.PANNo,
        STNo:Buyer.STNo,
        GSTNo:Buyer.GSTNo === '               ' ? '' : Buyer.GSTNo ,
        AccNo:Buyer.AccNo,
        AccBranch:Buyer.AccBranch,              
        IFSCCode:Buyer.IFSCCode,
        bank:Buyer.bank,
        CityId:Buyer.CityId,              
        RegisterType:Buyer.RegisterType,
        StateId:Buyer.StateId,
        CountryId:Buyer.CountryId,
        StateCode:Buyer.StateCode
    })
setcityonedefaultvalue({label:Buyer.City,value:Buyer.City})
setonestatedefaultvalue({label:Buyer.State,value:Buyer.StateId})
setonecountrydefaultvalue({label:Buyer.Country,value:Buyer.Country})
    // setUser({
    //   id: user.id,
    //   name: user.name,
    //   designation: user.designation,
    //   email: user.email,
    // })
    validation.values.GSTNo = Buyer.StateCode
    setIsEdit(true)

    toggle()
  }

  //delete user
  const [deleteModal, setDeleteModal] = useState(false)

  const onClickDelete = (Buyer) => {
    //setUser(user)
   //
   // //console.log(Buyer.BuyerId)
    setDeletiid(Buyer.Customer_Id)
    setDeleteModal(true)
  }

  const handleDeleteUser = () => {
    if (user.id) {
      dispatch(onDeleteUser(user))
      setDeleteModal(false)
    }
  }
  const handleUserClicks = () => {
    setUserList("")
    setIsEdit(false)
    toggle()
  }

 



    const DeleteBuyer =  async() => {
      const Deletbuy =  await axios.instance.delete(`/Deltecustomres/${Deletiid}`,
        { headers: {'Authorization':tokent,
        'Content-Type': 'application/json'
        }} 
      ).then((res) => {
        if(res.data === '') {
          getallcustomers()
          setBuyererr(true)
          setDeleteModal(false)
        }else {
          toastr.error('Already Used Cannot be Deleted','Customer')
          setDeleteModal(false)
        }
      
      })
    }


    const getallcustomers = async() => {
      const get= await axios.instance.get(`/Getallcustomersdetils/${localStorage.getItem('CompanyId')}`,{ headers: {'Authorization':tokent,
      'Content-Type': 'application/json',
      
      }}).then((res) => {
        setallcustomercollections(res.data)
      })
      }
      const Getallgroupid = async() => {
        const get= await axios.instance.get('/Getgroupid',{ headers: {'Authorization':tokent,
        'Content-Type': 'application/json',
        
        }}).then((res) => {
          setallgroupcollections(res.data)
          for(const data of res.data)
          {
            setgroupname(data.GroupName)
            setsubgroup(data.Under_GrpName)
          }
        })
        }



        const Getonecity = async() => {
          const get= await axios.instance.get('/Getonecity',{ headers: {'Authorization':tokent,
          'Content-Type': 'application/json',
          
          }}).then((res) => {
            setonecitycollections(res.data)
            for(const data of res.data)
            {
              setcityonedefaultvalue({label:data.City_Name,value:data.City_Name})
              setcityid(data.City_Name)
            }
          })
          }



          const Getonestates = async() => {
            const get= await axios.instance.get('/Getonestate',{ headers: {'Authorization':tokent,
            'Content-Type': 'application/json',
            
            }}).then((res) => {
              setonestaecollations(res.data)
              for(const data of res.data)
              {
                setonestatedefaultvalue({label:data.StateName,value:data.StateId})
                setstateid(data.StateName)
                setsatename(data.StateId)
                setstatecode(data.StateCode)
                 if (validation.values.RegisterType !='Unregistered'&& validation.values.RegisterType !='Composition') {
                  validation.values.GSTNo = data.StateCode
                 }else{
                   validation.values.GSTNo ='               '
                 }
              
              }
            })
            }
            const Getonecountry = async() => {
              const get= await axios.instance.get('/Getonecountry',{ headers: {'Authorization':tokent,
              'Content-Type': 'application/json',
              
              }}).then((res) => {
                setonecountrycollections(res.data)
                for(const data of res.data)
                {
                  setonecountrydefaultvalue({label:data.CountryName,value:data.CountryName})
                  setcountryid(data.CountryName)
                  
                }
              })
              }


      const Getallcountrys = async() => {
        const get= await axios.instance.get('/Getallcountry',{ headers: {'Authorization':tokent,
        'Content-Type': 'application/json',
        
        }}).then((res) => {
          
          const data  =res.data
          const options = data.map(b => ( {
          'label' : b.CountryName,
          'value' : b.CountryName
          }))
    
    setallcountrycollections(options)
        })
        }
        const Getallstate = async() => {
          const get= await axios.instance.get('/GetallStates',{ headers: {'Authorization':tokent,
          'Content-Type': 'application/json',
          
          }}).then((res) => {
            
            const data  = res.data
            const options = data.map(b => ( {
            'label' : b.StateName,
            'value' : b.StateId
            }))
      
      setallstatecollections(options)
          })
          }
  
          const Getallcity = async() => {
            const get= await axios.instance.get('/Getallcity',{ headers: {'Authorization':tokent,
            'Content-Type': 'application/json',
            
            }}).then((res) => {
              
              const data  = res.data
              const options = data.map(b => ( {
              'label' : b.City_Name,
              'value' : b.City_Name
              }))
        
        setallcitycollections(options)
            })
            }
       

          const getcountryid =(id) => {
           setcountryid(id)
          }     
          const getcityid =(id) => {
            setcityid(id)
          }    
const getstateid = (id) => {
  //console.log('t',id)
  setstateid(id.label)
  setsatename(id.value)
  setstatecode(id.value)
if(validation.values.RegisterType !='Unregistered'&& validation.values.RegisterType !='Composition') {
 
  validation.values.GSTNo=id.value
}else{

  validation.values.GSTNo='               '

}

 
}
useEffect(() => {
  Getallcountrys()
  getallcustomers()
  Getallcity()
  Getallstate()
  Getallgroupid()
  Getonecity()
  Getonestates()
  Getonecountry()
}, [])
const Offsymbol = () => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
        fontSize: 12,
        color: "#fff",
        paddingRight: 2,
      }}
    >
      {" "}
      No
    </div>
  )
}

const OnSymbol = () => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
        fontSize: 12,
        color: "#fff",
        paddingRight: 2,
      }}
    >
      {" "}
      Yes
    </div>
  )
}



  const columns = useMemo(
    () => [
     
     
      {
        Header: "Customer Name",
        filterable: true,
        accessor: "Customer_Name",
        disableFilters: true,
      },
     
      {
        Header: "State",
        filterable: true,
        accessor: "State",
        disableFilters: true,
      },
      {
        Header: "Action",
        accessor: "action",
        disableFilters: true,
        Cell: cellProps => {
          return (
            <div className="d-flex gap-3 users">
              <ul className="list-inline font-size-20 contact-links mb-0">
                <li className="list-inline-item">
                  <Link
                    to="#"
                    className="text-primary"
                    onClick={() => {
           
                      const Buyer = cellProps.row.original
                      handleUserClick(Buyer)
                    }}
                  >
                    <i className="uil uil-pen font-size-18" id="edittooltip" />
                    <UncontrolledTooltip placement="top" target="edittooltip">
                      Edit
                    </UncontrolledTooltip>
                  </Link>
                </li>
                <li className="list-inline-item">
                  <Link
                    to="#"
                    className="text-danger"
                    onClick={() => {
                      const Buyer = cellProps.row.original
                      onClickDelete(Buyer)
                    }}
                  >
                    <i
                      className="uil uil-trash-alt font-size-18"
                      id="deletetooltip"
                    />
                    <UncontrolledTooltip placement="top" target="deletetooltip">
                      Delete
                    </UncontrolledTooltip>
                  </Link>
                </li>
                <li className="list-inline-item dropdown">
                  {/* <UncontrolledDropdown>
                    <DropdownToggle
                      tag="a"
                      className="text-muted font-size-18 px-2"
                      caret
                    >
                      <i className="uil uil-ellipsis-v"></i>
                    </DropdownToggle>
                    <DropdownMenu className="dropdown-menu-end">
                      <DropdownItem href="#">Action</DropdownItem>
                      <DropdownItem href="#">Another action</DropdownItem>
                      <DropdownItem href="#">Something else here</DropdownItem>
                    </DropdownMenu>
                  </UncontrolledDropdown> */}
                </li>
              </ul>
            </div>
          )
        },
      },
    ],
    []
  )

  return (
    <React.Fragment>
      <DeleteModal
        show={deleteModal}
        onDeleteClick={DeleteBuyer}
        onCloseClick={() => setDeleteModal(false)}
      />
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs title=" Master" breadcrumbItem="Customer" />
          <Row>
          <Col xs="12">
              <Card>
                <CardBody>
                  <TableContainer
                    columns={columns}
                    data={allcustomercollections}
                    isGlobalFilter={true}
                    isAddUsers={true}
                    isAddTableWithoutBorderStrap={true}
                    handleUserClicks={handleUserClicks}
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
    
          <Modal   isOpen={modal} toggle={toggle}  size="lg"
     
     centered  >
           <ModalHeader toggle={toggle} tag="h4">
             {!!isEdit ? "Edit Customer" : "Add Customer"}
           </ModalHeader>
           <ModalBody>
           <div className="page-content " >
       <Container  style={{marginTop:-140}}>
    
       <Row>
           <Col lg="12">
             <Card >
               <CardBody>
            

                 <Nav tabs>
                   <NavItem>
                     <NavLink
                       style={{ cursor: "pointer", }}
                       className={classnames({
                         active: activeTab === "1",
                       })}
                       onClick={() => {
                         toggle12("1")
                       }}
                     >
                       <span className="d-block d-sm-none">
                       <i className="far fa-building"></i>
                       </span>
                       <span className="d-none d-sm-block">Basic Info</span>
                     </NavLink>
                   </NavItem>
                   <NavItem>
                     <NavLink
                       style={{ cursor: "pointer" }}
                       className={classnames({
                         active: activeTab === "2",
                       })}
                       onClick={() => {
                        tab1validtiontab1("2")
                       }}
                     >
                       <span className="d-block d-sm-none">
                         <i className="far fa-user"></i>
                       </span>
                       <span className="d-none d-sm-block">GST Info</span>
                     </NavLink>
                   </NavItem>
                  
                   <NavItem>
                     <NavLink
                       style={{ cursor: "pointer" }}
                       className={classnames({
                         active: activeTab === "3",
                       })}
                       onClick={() => {
                        tab1validtiontab2("3")
                       }}
                     >
                       <span className="d-block d-sm-none">
                       <i className="fas fa-university"></i>
                       </span>
                       <span className="d-none d-sm-block">Bank Info</span>
                     </NavLink>
                   </NavItem>
                 </Nav>

                 <TabContent activeTab={activeTab} className="p-3 text-muted">
                   <TabPane tabId="1">
                 
                             <Row>
                               <Col lg="4">
                                 <div className="mb-3">
                                   <Label for="basicpill-firstname-input1">
                                     Customer Name
                               </Label>
                                   <Input
                                   autoComplete="off"
                                   name="Customer_Name"
                                     type="text"
                                     className="form-control"
                                     id="basicpill-firstname-input1"
                                    
                                     onChange={validation.handleChange}
                                     onBlur={validation.handleBlur}
                                     value={validation.values.Customer_Name || ""}
                                     invalid={
                                       validation.touched.Customer_Name && validation.errors.Customer_Name ? true : false
                                     }
                                   />
                                        {validation.touched.Customer_Name && validation.errors.Customer_Name ? (
                         <FormFeedback type="invalid">{validation.errors.Customer_Name}</FormFeedback>
                       ) : null}
                                   
                          
                                 </div>
                               </Col>
                               <Col lg="4">
                                 <div className="mb-3">
                                   <Label for="basicpill-lastname-input2">
                                   Under Group
                               </Label>
                               <Input type="text" disabled  defaultValue={groupname}/>
                                      
                                 </div>
                               </Col>
                               <Col lg="4">
                                 <div className="mb-3">
                                 <Label for="basicpill-lastname-input2">
                                   Under Group
                               </Label>
                     <Input  autoComplete="off"
                                   name="Contact_Person"
                                     type="text"
                                     className="form-control"
                                     id="basicpill-firstname-input1"
                                    defaultValue={subgroup}
                                    disabled
                                    />
                                      
                                 </div>
                               </Col>
                               
                            
                             </Row>
<Row>
<Col lg="4">
    <div className="mb-3">
            <Label for="basicpill-lastname-input2">Contact Person  </Label>
            <Input
                                   autoComplete="off"
                                   name="Contact_Person"
                                     type="text"
                                     className="form-control"
                                     id="basicpill-firstname-input1"
                                    
                                     onChange={validation.handleChange}
                                     onBlur={validation.handleBlur}
                                     value={validation.values.Contact_Person || ""}
                                     invalid={
                                       validation.touched.Contact_Person && validation.errors.Contact_Person ? true : false
                                     }
                                   />
                                        {validation.touched.Contact_Person && validation.errors.Contact_Person ? (
                         <FormFeedback type="invalid">{validation.errors.Contact_Person}</FormFeedback>
                       ) : null}
                                      
                                 </div>
                               </Col>
                                  <Col lg="4">
                               <div className="mb-0" >
                                     <Label>Type of</Label>
                                     <Input type="select" name="Type"  className="form-select" style={{height:35}}
                                       onChange={validation.handleChange}
                                       onBlur={validation.handleBlur}
                                       value={validation.values.Type || ""}
                                       invalid={
                                         validation.touched.Type && validation.errors.Type ? true : false
                                       }
                                  
                                      >
                                    
                                      
                                       <option  value="Corporate"  >Corporate</option>
                                       <option value="Retailer">Retailer</option>
                                       <option value="Dealer">Dealer</option>
                                       <option value="Distributer">Distributer</option>
                                       <option value="OEM">OEM</option>
                                       <option value="End User">End User</option>

                                      </Input>
                                 
                                  
                                   </div>
                                 
                               </Col>
                               <Col lg="4">
                                 <div className="mb-3 col-12">
                                   <Label for="basicpill-phoneno-input3">
                                    Address1
                               </Label>
                                   <Input
                                     autoComplete="off"
                                   name="Address1"
                                     type="textarea"
                                     rows="3"
                                     className="form-control"
                                 style={{margintop:1}}
                                 size="sm"
                                 onChange={validation.handleChange}
                                 onBlur={validation.handleBlur}
                                 value={validation.values.Address1 || ""}
                                 invalid={
                                   validation.touched.Address1 && validation.errors.Address1 ? true : false
                                 }
                               />
                                    {validation.touched.Address1 && validation.errors.Address1 ? (
                     <FormFeedback type="invalid">{validation.errors.Address1}</FormFeedback>
                   ) : null}
                                 </div>
                               </Col>
</Row>
                             <Row>
                               
                               <Col lg="4">
                                 <div className="mb-3 col-12">
                                   <Label for="basicpill-phoneno-input3">
                                    Address2
                               </Label>
                                   <Input
                                     autoComplete="off"
                                   name="Address2"
                                     type="textarea"
                                     rows="3"
                                     className="form-control"
                                 style={{margintop:1}}
                               
                                 onChange={validation.handleChange}
                                 onBlur={validation.handleBlur}
                                 value={validation.values.Address2 || ""}
                                 invalid={
                                   validation.touched.Address2 && validation.errors.Address2 ? true : false
                                 }
                               />
                         
                                 </div>
                               </Col>
                               <Col lg="4">
                               <div className="mb-0" >
                                     <Label>Country</Label>
                                     <Select
                                name="CategoryId"
                        options={allcountrycollections}
                       //ref={categoryref}
                     classNamePrefix="select2-search-disable"
                  onChange={(value)=>  getcountryid(value.value)}
                  defaultValue={onecountrydefaultvalue}
                   />   
                           
                                  
                                   </div>
                                   <Label for="basicpill-email-input4" >
                                 City
                               </Label>
                               <div className="mb-0" >
                                  
                               <Select
                                name="CategoryId"
                       options={allcitycollections}
                       //ref={categoryref}
                     classNamePrefix="select2-search-disable"
                    onChange={(value)=>  getcityid(value.value)}
                   defaultValue={cityonedefaultvalue}
                   />   
                             
                                   </div>

                               </Col>
                               <Col lg="4">
                               <div className="mb-0" >
                                     <Label>State</Label>
                                     <Select
                                name="CategoryId"
                       options={allstatecollections}
                       //ref={categoryref}
                     classNamePrefix="select2-search-disable"
                    onChange={(value)=>  getstateid(value)}
                  defaultValue={onestatedefaultvalue}
                   />   
                             
                                   </div>
                                   <Label for="basicpill-address-input1">
                                   Pin Code
                               </Label>
                               <Input
                                 autoComplete="off"
                               name="Zip_Code"
                                     type="number"
                                     className="form-control"
                                     id="basicpill-email-input4"
                                     onChange={validation.handleChange}
                                     onBlur={validation.handleBlur}
                                     value={validation.values.Zip_Code || ""}
                                     invalid={
                                       validation.touched.Zip_Code && validation.errors.Zip_Code ? true : false
                                     }
                                   />
                                             {validation.touched.Zip_Code && validation.errors.Zip_Code ? (
                         <FormFeedback type="invalid">{validation.errors.Zip_Code}</FormFeedback>
                       ) : null}
                              
                               </Col>
                                   <Col lg="4" >
                                         <div className="mb-0 " >
                                     
                            
                              
                                 
                                   <Label for="basicpill-address-input1">
                                   Phone No
                               </Label>
                               <Input
                                 autoComplete="off"
                               name="Phone"
                                     type="number"
                                     className="form-control"
                                     id="basicpill-email-input4"
                                     onChange={validation.handleChange}
                                     onBlur={validation.handleBlur}
                                     value={validation.values.Phone || ""}
                                     invalid={
                                       validation.touched.Phone && validation.errors.Phone ? true : false
                                     }
                                   />
                                               {validation.touched.Phone && validation.errors.Phone ? (
                         <FormFeedback type="invalid">{validation.errors.Phone}</FormFeedback>
                       ) : null}
                              
                              
                                 </div>
                               </Col>
                              
                               <Col lg="4" >
                                         <div className="mb-0 " >
                                     
                            
                              
                                 
                                   <Label for="basicpill-address-input1">
                                   Mobile No
                               </Label>
                               <Input
                                 autoComplete="off"
                               name="Area_Code"
                                     type="text"
                                     className="form-control"
                                     id="basicpill-email-input4"
                                     onChange={validation.handleChange}
                                     onBlur={validation.handleBlur}
                                     value={validation.values.Area_Code || ""}
                                     invalid={
                                       validation.touched.Area_Code && validation.errors.Area_Code ? true : false
                                     }
                                   />
                            
                            {validation.touched.Area_Code && validation.errors.Area_Code ? (
                         <FormFeedback type="invalid">{validation.errors.Area_Code}</FormFeedback>
                       ) : null}
                                 </div>
                               </Col>
                               
                               <Col lg="4" >
                                         <div className="mb-0 " >
                                     
                            
                              
                                 
                                   <Label for="basicpill-address-input1">
                                   Email Id
                               </Label>
                               <Input
                                 autoComplete="off"
                               name="EmailId"
                                     type="email"
                                     className="form-control"
                                     id="basicpill-email-input4"
                                     onChange={validation.handleChange}
                                     onBlur={validation.handleBlur}
                                     value={validation.values.EmailId || ""}
                                     invalid={
                                       validation.touched.EmailId && validation.errors.EmailId ? true : false
                                     }
                                   />
                                                {validation.touched.EmailId && validation.errors.EmailId ? (
                         <FormFeedback type="invalid">{validation.errors.EmailId}</FormFeedback>
                       ) : null}
                              
                              
                                 </div>
                               </Col>
                            
                             </Row>
                             <Row>
                             <Col lg="4" >
                                         <div className="mb-0 " >
                                     
                            
                              
                                 
                                   <Label for="basicpill-address-input1">
                                  Fax
                               </Label>
                               <Input
                                 autoComplete="off"
                               name="Fax"
                                     type="number"
                                     className="form-control"
                                     id="basicpill-email-input4"
                                     onChange={validation.handleChange}
                                     onBlur={validation.handleBlur}
                                     value={validation.values.Fax || ""}
                                     invalid={
                                       validation.touched.Fax && validation.errors.Fax ? true : false
                                     }
                                   />
                                                {validation.touched.Fax && validation.errors.Fax ? (
                         <FormFeedback type="invalid">{validation.errors.Fax}</FormFeedback>
                       ) : null}
                              
                              
                                 </div>
                               </Col>
                               <Col xl={3}>
                      <h5 className="font-size-14 mb-3">Active 
</h5>
{isEdit ? (
                                   <div className="mt-2">
                                {allcustomercollections.Active = "Y" ? (

                               
                                   <Switch
                             uncheckedIcon={<Offsymbol />}
                             checkedIcon={<OnSymbol />}
                             onColor="#626ed4"
                             onChange={() => {
                               setswitch1(!switch1)
                             }}
                             checked={switch1}
                           />
         
                           ) : (
                                
                            <Switch
                            uncheckedIcon={<Offsymbol />}
                            checkedIcon={<OnSymbol />}
                            onColor="#626ed4"
                            onChange={() => {
                              setswitch1(switch1)
                            }}
                            checked={!switch1}
                          />
                           )} 
                            
                                       </div>  
                                  ) : (

                                  
                               
                                   
                        
               
                          <div className="mt-2">
                           
                          <Switch
                    uncheckedIcon={<Offsymbol />}
                    checkedIcon={<OnSymbol />}
                    onColor="#626ed4"
                    onChange={() => {
                      setswitch1(!switch1)
                    }}
                    checked={switch1}
                  />
                      
                        
                   
                              </div>
                               )} 
                    </Col>
                             </Row>
                             <Row>
                              
                           
                            
                              
                              
                               <div className="d-flex flex-wrap gap-3 justify-content-end mt-4">
                   <Button
                     color="primary"
                     className="waves-effect waves-light"
                     onClick={() => {
                      tab1validtiontab1("2")
                     }}
                   >
                     Next
                   </Button>{" "}
                   </div>
                             </Row>
                             

                   </TabPane>
                   <TabPane tabId="2" className="p-3">
                   <Form>
                               <Row>
                                 <Col lg="3">
                                   <div className="mb-3">
                                     <Label for="basicpill-pancard-input5">
                                    
                                  Registration Type
                                 </Label>
                                 <Input type="select" name="RegisterType"  className="form-select" style={{height:35}}
                                       onChange={validation.handleChange}
                                       onBlur={validation.handleBlur}
                                       value={validation.values.RegisterType || ""}
                                       invalid={
                                         validation.touched.RegisterType && validation.errors.RegisterType ? true : false
                                       }
                                      
                                      >
                                     
                                  
                                       <option  value="Registered" >Registered</option>
                                       <option value="Unregistered">Un Registered</option>
                                       <option value="SEZ">SEZ</option>
                                       <option value="Composition">Composition</option>
                                      
                                 

                                     </Input>
                          
                                   </div>
                                 </Col>

                                 <Col lg="4">
                                   <div className="mb-3">
                                     <Label for="basicpill-vatno-input6">
                                   Registration Date
                                 </Label>
                                     <Input
                                       autoComplete="off"
                                       type="date"
                                       name="MobileNo"
                                       className="form-control"
                                       id="basicpill-vatno-input6"
                                       
                                
                                    value={moment(registerdate).format('YYYY-MM-DD')}
                                    onChange={(e)=>setregisterdate(e.target.value)}
                                      />
                         
                                   </div>
                                 </Col>
                                 <Col lg="5">
                                   <div className="mb-3">
                                     <Label for="basicpill-cstno-input7">
                                      GSTIN/UIN
                                 </Label>
                                     <Input
                                       autoComplete="off"
                                       type="text"
                                         name="GSTNo"
                                       className="form-control"
                                       id="basicpill-cstno-input7"
                                       disabled={validation.values.RegisterType === 'Unregistered' && validation.values.GSTNo === '' }
                                         onChange={validation.handleChange}
                                         onBlur={validation.handleBlur}
                                         value={validation.values.GSTNo || ""}
                                         invalid={
                                           validation.touched.GSTNo && validation.errors.GSTNo ? true : false
                                         }
                                       />
                                                {validation.touched.GSTNo && validation.errors.GSTNo ? (
                         <FormFeedback type="invalid">{validation.errors.GSTNo}</FormFeedback>
                       ) : null}
                                   </div>
                                 </Col>
                               
                                 <Col lg="5">
                                   <div className="mb-3">
                                     <Label for="basicpill-cstno-input7">
                                      PAN No
                                 </Label>
                                     <Input
                                       autoComplete="off"
                                       type="text"
                                         name="PANNo"
                                       className="form-control"
                                       id="basicpill-cstno-input7"
                                       
                                         onChange={validation.handleChange}
                                         onBlur={validation.handleBlur}
                                         value={validation.values.PANNo || ""}
                                         invalid={
                                           validation.touched.PANNo && validation.errors.PANNo ? true : false
                                         }
                                       />
                            
                                   </div>
                                 </Col>
                                 <Col lg="4">
                                   <div className="mb-3">
                                     <Label for="basicpill-vatno-input6">
                                  CIN
                                 </Label>
                                     <Input
                                       autoComplete="off"
                                       name="TIN_No"
                                       type="text"
                                       className="form-control"
                                       id="basicpill-vatno-input6"
                                   
                                  
                                     onChange={validation.handleChange}
                                     onBlur={validation.handleBlur}
                                     value={validation.values.TIN_No || ""}
                                     invalid={
                                       validation.touched.TIN_No && validation.errors.TIN_No ? true : false
                                     }
                                   />
                          
                                   </div>
                                 </Col>
                              
                               </Row>
                               <Row>


                                
                               </Row>
                               <Row>
                                
                                 <div className="d-flex flex-wrap gap-3 justify-content-end mb-3">
                   <Button
                     color="primary"
                     className="waves-effect waves-light"
                     onClick={() => {
                      tab1validtiontab2("3")
                     }}
                   >
                     Next
                   </Button>{" "}
                   </div>
                               </Row>
                             </Form>
                   </TabPane>
                  
                   <TabPane tabId="3" className="p-4">
                   <Row>
                                 <Col lg="6">
                                   <div className="mb-3">
                                     <Label for="basicpill-cardno-input12">
                                    Bank Name 
                                 </Label>
                                     <Input
                                       autoComplete="off"
                                     name="bank"
                                       type="text"
                                       className="form-control"
                                       id="basicpill-cardno-input12"
                                     
                                       onChange={validation.handleChange}
                                       onBlur={validation.handleBlur}
                                       value={validation.values.bank || ""}
                                       invalid={
                                         validation.touched.bank && validation.errors.bank ? true : false
                                       }
                                     />
                                                 {validation.touched.bank && validation.errors.bank ? (
                         <FormFeedback type="invalid">{validation.errors.bank}</FormFeedback>
                       ) : null}
                                   </div>
                                 </Col>

                                 <Col lg="6">
                                   <div className="mb-3">
                                     <Label for="basicpill-card-verification-input">
                                     Branch Name
                                 </Label>
                                     <Input
                                       autoComplete="off"
                                       type="text"
                                        name="AccBranch"
                                       className="form-control"
                                       id="basicpill-card-verification-input"
                                    
                                   
                                       onChange={validation.handleChange}
                                       onBlur={validation.handleBlur}
                                       value={validation.values.AccBranch || ""}
                                       invalid={
                                         validation.touched.AccBranch && validation.errors.AccBranch ? true : false
                                       }
                                     />
                                                  {validation.touched.AccBranch && validation.errors.AccBranch ? (
                         <FormFeedback type="invalid">{validation.errors.AccBranch}</FormFeedback>
                       ) : null}
                                   </div>
                                 </Col>
                               </Row>
                               <Row>
                                 <Col lg="6">
                                   <div className="mb-3">
                                     <Label for="basicpill-cardno-input12">
                                     Account No
                                 </Label>
                                     <Input
                                       autoComplete="off"
                                     name="AccNo"
                                       type="text"
                                       className="form-control"
                                       id="basicpill-cardno-input12"
                                    
                                     
                                       onChange={validation.handleChange}
                                       onBlur={validation.handleBlur}
                                       value={validation.values.AccNo || ""}
                                       invalid={
                                         validation.touched.AccNo && validation.errors.AccNo ? true : false
                                       }
                                     />
                                                       {validation.touched.AccNo && validation.errors.AccNo ? (
                         <FormFeedback type="invalid">{validation.errors.AccNo}</FormFeedback>
                       ) : null}
                                   </div>
                                 </Col>

                                 <Col lg="6">
                                   <div className="mb-3">
                                     <Label for="basicpill-card-verification-input">
                                IFSCCode
                                 </Label>
                                     <Input
                                       autoComplete="off"
                                     name="IFSCCode"
                                       type="text"
                                       className="form-control"
                                       id="basicpill-card-verification-input"
                                      
                                   
                                       onChange={validation.handleChange}
                                       onBlur={validation.handleBlur}
                                       value={validation.values.IFSCCode || ""}
                                       invalid={
                                         validation.touched.IFSCCode && validation.errors.IFSCCode ? true : false
                                       }
                                     />
                                                      {validation.touched.IFSCCode && validation.errors.IFSCCode ? (
                         <FormFeedback type="invalid">{validation.errors.IFSCCode}</FormFeedback>
                       ) : null}
                                   </div>
                                
                                 </Col>
                               </Row>
                               <Row>
                            
                                 <Col>
                                 {isEdit ? (
                                 <div className="d-flex flex-wrap gap-3 justify-content-end mb-3 mt-5">
                   <Button
                     color="primary"
                     className="waves-effect waves-light"
                     onClick={(e) => {
                      e.preventDefault();
                     validation.handleSubmit()
                     return false
                    }}
                   >
                     Update
                   </Button>{" "}
                   </div>
                   ):             
                       <div className="d-flex flex-wrap gap-3 justify-content-end mb-3 mt-5">
                   <Button
                     color="primary"
                     className="waves-effect waves-light"
                     onClick={(e) => {
                      e.preventDefault();
                     validation.handleSubmit()
                     return false
                    }}
                   >
                     Save
                   </Button>{" "}
                   </div>}
                                 </Col>
                               </Row>
                   </TabPane>
                 </TabContent>
               </CardBody>
             </Card>
           </Col>
           </Row>

       
       </Container> 
     </div>
            </ModalBody>
         </Modal> 
        </div>
      </div>






      {Buyersuccess ? (
                    <SweetAlert
                      title="Customer Added Successfully"
                      timeout={2000}
                      style={{
                        position: "absolute",
                         justifyContent:'center',
                         alignItems:'center'
                      }}
                      showCloseButton={false}
                      showConfirm={false}
                      success
                      onConfirm={() => {
                        setBuyersuccess(false);
                      }}
                    ></SweetAlert>
                  ) : null}
                  
      {Buyerinfo ? (
                    <SweetAlert
                      title="Customer Info Updated Successfully"
                      timeout={2000}
                      style={{
                        position: "absolute",
                         justifyContent:'center',
                         alignItems:'center'
                      }}
                      showCloseButton={false}
                      showConfirm={false}
                      success
                      onConfirm={() => {
                        setBuyerinfo(false);
                      }}
                    ></SweetAlert>
                  ) : null}
                  
      {Buyererr ? (
                    <SweetAlert
                      title="Customer Deleted  Successfully"
                      timeout={2000}
                      style={{
                        position: "absolute",
                         justifyContent:'center',
                         alignItems:'center'
                      }}
                      showCloseButton={false}
                      showConfirm={false}
                      success
                      onConfirm={() => {
                        setBuyererr(false);
                      }}
                    ></SweetAlert>
                  ) : null}

                  
      {duplicateerro ? (
                    <SweetAlert
                      title="Customer Already exists "
                      timeout={2000}
                      style={{
                        position: "absolute",
                         justifyContent:'center',
                         alignItems:'center'
                      }}
                      showCloseButton={false}
                      showConfirm={false}
                      danger
                      onConfirm={() => {
                        setduplicateerro(false);
                      }}
                    ></SweetAlert>
                  ) : null}


    </React.Fragment>
  )
}
DatatableTables.propTypes = {
  preGlobalFilteredRows: PropTypes.any,
}

export default DatatableTables
